import CryptoJS from 'crypto-js';

// AES配置 - 与后端Java代码保持一致
const AES_KEY = '9vok8x4yri507ngmplhs3uq6cfbz2a1t';
const AES_IV = 'e9yu7sz2xrn30bf5'; // 固定IV，16字节

/**
 * AES-256-CBC 加密（使用固定IV，与后端Java AES/CBC/PKCS7Padding保持一致）
 * @param plainText 明文
 * @returns 加密后的Base64字符串（URL-safe，无填充）
 */
export function aesEncrypt(plainText) {
    try {
        const startTime = Date.now();

        // 如果输入不是字符串，转换为JSON字符串
        let message = plainText;
        if (typeof plainText !== 'string') {
            message = JSON.stringify(plainText);
        }

        // 使用固定的IV（与后端一致）
        const iv = CryptoJS.enc.Utf8.parse(AES_IV);
        const key = CryptoJS.enc.Utf8.parse(AES_KEY);

        // AES-256-CBC加密
        const encrypted = CryptoJS.AES.encrypt(message, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // 只返回密文，不包含IV（因为IV是固定的）
        const result = encrypted.ciphertext
            .toString(CryptoJS.enc.Base64)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

        const endTime = Date.now();
        console.log(`aesEncrypt: ${endTime - startTime}ms`);

        return result;
    } catch (error) {
        console.error('AES加密失败:', error);
        throw error;
    }
}

/**
 * AES-256-CBC 解密（使用固定IV，与后端Java AES/CBC/PKCS7Padding保持一致）
 * @param cipherText 密文（Base64 URL-safe编码，无填充）
 * @returns 解密后的明文
 */
export function aesDecrypt(cipherText) {
    try {
        const startTime = Date.now();

        // 还原URL-safe字符为标准Base64
        const base64Content = cipherText.replace(/-/g, '+').replace(/_/g, '/');

        // 补充Base64填充字符
        const paddedBase64 = base64Content + '='.repeat((4 - (base64Content.length % 4)) % 4);

        // 使用固定的IV和密钥（与后端一致）
        const iv = CryptoJS.enc.Utf8.parse(AES_IV);
        const key = CryptoJS.enc.Utf8.parse(AES_KEY);

        // 直接解密整个数据（因为数据中不包含IV，只有纯密文）
        const decrypted = CryptoJS.AES.decrypt(paddedBase64, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // 转换为UTF-8字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
            throw new Error('解密失败，可能是密钥不匹配或数据损坏');
        }

        const endTime = Date.now();
        console.log(`aesDecrypt: ${endTime - startTime}ms`);

        return decryptedText;
    } catch (error) {
        console.error('AES解密失败:', error);
        throw error;
    }
}

export const encrypt = aesEncrypt;
export const decrypt = aesDecrypt;
